<template>
 	<div id="outofserviceCreate">
   		<div :class="`loader${loaderClass}`" v-show="loading"></div>
	   	<div id="page-content-wrapper" class="admin-content-area">
			<div class="page-name" >
				<span class="page-title" id="pageHeader">Out Of Service</span>
				<button type="button" class="btn btn-secondary pull-right" v-on:click.prevent="backToList()" >
					<i class="fp-back"> </i> Back
				</button>
			</div>
			<template v-if="cantAccessPage === true">
				<div class="container-fluid">
					<div class="admin-page-content time-store">
					   	<section class="internal-container border-top-table-fl">
						   	<div class="table-responsive-sm">
							  	<table aria-describedby="table" class="table table-sm">
								  	<thead>
										<tr class="table-active">
											<th class="require" style="width:300px">Unit</th>
											<th class="require" style="width:300px">Start Date Time</th>
											<th style="width:300px">Work Order</th>
											<th class="require" style="width:500px">Comment</th>
											<th style="width:300px">&nbsp;</th>
										</tr>
								  	</thead>
								  	<tbody>
									  	<tr>
											<td>
												<v-select v-model="vehicle_id" name="vehicle_id"
													label="text" :filterable="false" :options="vehicleArr"
													@search="onSearchVehicle" @input="SearchWorkOrder"
													placeholder="Select Unit" class="custom-ci-auto-search" :disabled="IsUpdate">
													<template slot="no-options">
														Search Unit...
													</template>
													<template slot="option" slot-scope="option">
														<div class="d-center">
															{{ option.text }}
														</div>
													</template>
													<template slot="selected-option" slot-scope="option">
														<div class="selected d-center">
															{{ option.text }}
														</div>
													</template>
												</v-select>
												<div class="text-danger">{{vehicleError}}</div>
											</td>
											<td style="text-align: center;">
											<!-- OR -->
												<div class="input-group form-group mb-0">
													<date-picker placeholder="MM/DD/YYYY HH:mm:ss" id="oos_start_date" name="oos_start_date" v-model="oos_start_date" :config="optionsDateTime" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
													<label for="oos_start_date" class="fp-calendar input-calender-icon"></label>
												</div>
												<div class="text-danger">{{dateError}}</div>
											</td>
											<td>
												<v-select
													v-model="workOrder"
													name="work_order"
													placeholder="Select Work Order."
													label="text"
													:options="workOrderArr"
													:filterable="true"
													:clearable="true">
												</v-select>
												<!-- <font class="text-danger">{{workOrderError}}</font> -->
											</td>
											<td>
												<textarea class='form-control' v-model="comment" ref="textarea" id="comment" rows="2"></textarea>
												<div class="text-danger">{{commentError}}</div>
											</td>

											<td>
												<button type="button" class="btn btn-primary " v-on:click.prevent="OutOfServiceStart()">
													<i class="fp-save"> </i> Submit
												</button>
											</td>
										</tr>
								</tbody>
							</table>
						  </div>
					   </section>
					</div>
				</div>
				</template>
				<template v-else-if="cantAccessPage === false">
					<div class="container-fluid">
					  <div class="bg-white text-center">
						  <h1>
							  Oops!</h1>
						  <h2>
							  403 </h2>
						  <div class="error-details">
							  Sorry!, You don't have permission to access this page.
						  </div>
					  </div>
				  </div>
			  </template>
			  <template v-else>
				  <loading-content></loading-content>
			  </template>
			  <app-footer></app-footer>
	   </div>
 </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';
  
import moment from 'moment';
var self;

export default {
   name: "OutOfService",
   metaInfo: {
	  // title will be injected into parent titleTemplate
	  title: "Out Of Service | " +process.env.COPYRIGHT_NAME
   },
	mixins: [commonMixins, contractMixins],
	 data: () => ({
		workOrder : null,
		workOrderArr: [],
		loading:false,
		responseArray:'',
		optionsDateTime:{
			format: 'MM/DD/YYYY hh:mm:ss a',
			useCurrent: true,
			showClose:true
		},
		userId : 0,
		error:'',
		firstLoad : 0,
		permissions:[],
		cantAccessPage:"",
		canUpdateEtk:false,
		eventPerformed:"",
		vehicleArr:[],
		vehicle_id:'',
		oos_start_date:'',
		dateError:'',
		vehicleError:'',
		IsUpdate:false,
		comment:'',
		commentError:''
	 }),
	 watch:{

		permissions: function(permission){
			var self = this;
			permission.forEach(function (permissions) {
				if(permissions.name == 'can_place_out_of_service') {
					self.cantAccessPage = true;
				}
			});
		},
	},
	 beforeMount() {
	  self = this;
	 },
	 mounted() {
		var userObj = JSON.parse(localStorage.getItem("user_obj"));
		if (userObj != null) {
			console.log(userObj.first_name);
			self.userId = userObj.id;
			self.first_name = userObj.first_name;
		}
		if (self.$route.params && self.$route.params.id != undefined){
			self.IsUpdate = true;
		}
		if(self.$route.params.id != undefined){
			self.fetchOOSDetail();
		}
		this.getPermissions();
	 },
	 methods: {
		onSearchVehicle(search, loading) {
			var self = this;
			if (search.length > 3) {
				loading(true);
				self.searchField(loading, search, 'vehicle', '');
			}
		},

		cancelAll: function (cancelAll) {
			this.$refs.listTransportRequest.unselectAllInternal();
		},


		SearchWorkOrder: function() {
			var self = this;
			$.ajax({
				url: process.env.ROOT_API + '/workorder-by-vehicle/'+self.vehicle_id.value,
				type: "GET",
				crossDomain: true,
				dataType: "json",
				data:{
					flag:'all'
				},
				headers: this.ajxHeaders,
				success: function(data) {

					if (data.status == "success") {
						if (data.result && data.result.length){
							var wodata = data.result;
							for(var i=0;i<wodata.length;i++){
								self.workOrderArr.push({text:wodata[i].work_order_no,value:wodata[i].id});
							}
						}else{
							self.workOrder = '';
							self.workOrderArr = [];
						}
						// self.workOrderArr = data.content;
					}else{
						self.workOrder = '';
						self.workOrderArr = [];
					}
				},
				error: function(jqXHR, exception) {
						self.generateStatusCodeMessage(jqXHR, true, 'get-current-wo')
					}
				});

		},
		
		OutOfServiceStart: function () {
			var self = this;
			var error = false;
			self.dateError = '';
			self.vehicleError = '';
			var dataField = [];
			if (self.vehicle_id == null || !self.vehicle_id.value){
				self.vehicleError = 'Unit Required';
				error = true;
			}
			if (self.oos_start_date == null || self.oos_start_date == '' || !self.oos_start_date){
				self.dateError = 'Start Date Required';
				error = true;
			}
			if (self.comment == null || self.comment == '' || !self.comment ){
				self.commentError = 'Comment Required';
				error = true;
			}

			if ( !error ) {
				
				self.loading = true;
				dataField.push({name:'vehicle_id',value:self.vehicle_id.value});
				dataField.push({name:'start_date',value:self.oos_start_date});
				dataField.push({name:'comment',value:self.comment});
				if (self.workOrder != null && self.workOrder.value){
					dataField.push({name:'work_order_id',value:self.workOrder.value});
				}else{
					dataField.push({name:'work_order_id',value:''});
				}
				if (self.$router.params && self.$router.params.id != undefined){
					dataField.push({name:'id',value:self.$router.params.id});
				}

				$.ajax({
					url: process.env.ROOT_API + "/out-of-service/add",
					type: "POST",
					crossDomain: true,
					dataType: "json",
					headers: this.ajxHeaders,
					data: dataField,
					success: function(data) {
						self.loading = false;
						if (data.status == "success") {
							self.$router.push('/out-of-service/list');
						}
					},
					error: function(jqXHR, exception) {
						self.loading = false;
						self.generateStatusCodeMessage(jqXHR, true, 'get-log-view')
					}
				});
			}
		},

		fetchOOSDetail: function() {
			var self = this;
			$.ajax({
				url: process.env.ROOT_API + '/one-oos/'+self.$route.params.id,
				type: "GET",
				crossDomain: true,
				dataType: "json",
				headers: this.ajxHeaders,
				success: function(data) {

					if (data.status == "success") {
						self.vehicle_id = {text:data.content.unit_no+' | '+data.content.vehicle_name,value:data.content.vehicle_id};
						self.workOrder = data.content.work_order_id != null ? {text:data.content.work_order_no,value:data.content.work_order_id}:'';
						self.oos_start_date = data.content.start_date;
						self.comment = data.content.comment;
					}else{

					}
				},
				error: function(jqXHR, exception) {
						self.generateStatusCodeMessage(jqXHR, true, 'get-current-oos')
					}
				});

		},

		backToList:function(){
			var self = this;
			self.$router.push('/out-of-service/list');
		},
		
		openModal: function(flag){
			var self = this;
			self.enteredPin = "";

			if ( flag == "start" ) {

				self.eventPerformed = flag;

				if ( self.checkLogEntry() ) {

					$("#typeImage").val('');
					$('#myModal').modal('show');
				}

			} else {

				self.eventPerformed = flag;
				$('#myModal').modal('show');
			}

		},


	 },

}
</script>




// WEBPACK FOOTER //
// src/components/OutOfServiceCreate.vue